<div class="content-grid-wrapper h-full">
  <div class="col-span-10">
    <app-content-header
      [title]="dashboardHeaderTitle"
      titleClass="text-primaryText"
      [description]="'RM.DASHBOARD.DESCRIPTION' | translate"
    />
  </div>

  <div class="col-span-10 grid grid-cols-12 gap-(--spacing-layout-l)">
    <app-rm-stats-widget class="contents" />

    <app-rm-open-actions
      class="col-span-12"
      [items]="openActionsState().data?.items ?? []"
      [totalCount]="openActionsState().data?.totalCount ?? 0"
      [loading]="openActionsState().loading"
    />

    <app-rm-live-deals class="col-span-12" />

    <app-rm-deal-cards
      class="col-span-12"
      titleKey="RM.DASHBOARD.CLOSING_SOON.TITLE"
      emptyKey="RM.DASHBOARD.CLOSING_SOON.EMPTY"
      viewAllLink="/rm/deal-management/deals/closing"
      [items]="closingSoonState().data?.items ?? []"
      [totalCount]="closingSoonState().data?.totalCount ?? 0"
      [loading]="closingSoonState().loading"
    />

    <app-rm-sector-preferences
      class="col-span-12"
      [items]="sectorPreferencesState().data ?? []"
      [loading]="sectorPreferencesState().loading"
    />

    @if (aiFeatureEnabled) {
    <app-rm-ai-summary class="col-span-12" />
    }
  </div>
</div>
